import axios from "axios";

let _singleton = true;
let _instance: any;
let _user: any;

class AuthAdapter {
  constructor() {
    if (_singleton) {
      throw new SyntaxError("This is singleton class");
    }
  }

  static get instance() {
    if (!_instance) {
      _singleton = false;
      _instance = new AuthAdapter();
      _singleton = true;
    }
    return _instance;
  }

  static getAuthenticate() {
    // logic to get authrise user
    // set user here
    // user(authDetails)
  }

  set user(authDetails: any) {
    _user = authDetails;
  }

  get user() {
    return _user;
  }
}

export default AuthAdapter;
